import React, { useState } from "react"
import { useDispatch } from "react-redux"
import ButtonMutation from "components/Molecules/ButtonMutation"
import DynamicMultiSelector from "components/Molecules/DynamicMultiSelector"
import { ALL_DEPARTMENTS } from "graphql/selector.queries.gql"
import { BULK_UPDATE_VEHICLE_DEPARTMENTS } from "graphql/vehicle/vehicle.mutations.gql"
import { UPDATE_SELECTED_VEHICLE } from "store/all-vehicles/all-vehicles.actions"
import { getId } from "utils/custom.utils"
const VehicleDepartments = ({ vehicle }) => {
  const dispatch = useDispatch()
  const [departments, setDepartments] = useState(vehicle?.departments)
  return (
    <div className="vt-department-update-form">
      <DynamicMultiSelector
        inline
        fill
        className="vt-department-selector"
        value={departments}
        onChange={(_, value) => setDepartments(value)}
        query={ALL_DEPARTMENTS}
        label="Departments"
      />
      <div className="flex justify-end mb-3">
        <ButtonMutation
          icon="confirm"
          text="Update Departments"
          mutation={BULK_UPDATE_VEHICLE_DEPARTMENTS}
          onCompleted={({ bulkUpdateVehicleStatus: vs }) => {
            dispatch({
              type: UPDATE_SELECTED_VEHICLE,
              payload: vs?.vehicles?.[0],
            })
          }}
          variables={{
            departments: departments?.map(getId),
            vehicles: [vehicle?.id],
          }}
        />
      </div>
    </div>
  )
}

export default VehicleDepartments
